import React, { useEffect, useState } from 'react';

import { Row, Col, Flex, LoadingDots } from '@app/ui';

import sendEmails from './sendEmails';

const EmailNotifications = () => {
    const [isLoading, setLoading] = useState(true);
    const [emails, setEmailInfo] = useState([]);

    useEffect(() => {
        if (location && location.search.length > 0) {
            const params = new URLSearchParams(location.search.slice(1));

            const ids = params.getAll('id');
            if (!ids || ids.length === 0) return;
            (async () => {
                const { emails: emailInfo } = await sendEmails(ids);
                setEmailInfo(emailInfo);
                setLoading(false);
            })();
        }
    }, []);

    return (
        <Flex
            vertical
            style={{
                margin: '1em',
            }}
            className="gds-layout__container"
        >
            <Row gutter={16}>
                <Col sm={24}>{isLoading && <LoadingDots />}</Col>
                <Col sm={24}>
                    {!isLoading && emails && emails.length > 0 && (
                        <Flex vertical className="gds-layout__container">
                            <Row gutter={16}>
                                <Col sm={8}>User</Col>
                                <Col sm={8}>Sent</Col>
                                <Col sm={8}>Message</Col>
                            </Row>

                            {emails.map((el, i) => {
                                const { user, sent, message } = el;
                                const iconType = sent ? 'check' : 'times';
                                return (
                                    <Row gutter={16} key={i}>
                                        <Col sm={8}>{user}</Col>
                                        <Col sm={8}>
                                            <i
                                                className={`fas fa-${iconType}`}
                                                style={{
                                                    color: sent
                                                        ? 'green'
                                                        : 'red',
                                                }}
                                            />
                                        </Col>
                                        <Col sm={8}>{message}</Col>
                                    </Row>
                                );
                            })}
                        </Flex>
                    )}
                    {!isLoading && (!emails || emails.length === 0) && (
                        <p>No email was sent.</p>
                    )}
                </Col>
            </Row>
        </Flex>
    );
};

export default EmailNotifications;
